// extracted by mini-css-extract-plugin
export default {"content":"HomePage_content__L+Tmc","intro":"HomePage_intro__9tg4a"};